import { makeStyles } from "@material-ui/core";

export const useCoreStyles = makeStyles({
  list: { width: "clamp(300px, 60%, 100%)" },
});
